import Modal from '../../../common/modal/src/modal';
import './agreement.sass';

export default {
	model: {
		prop: 'checked',
		event: 'change'
	},

	props: {
		readOnly: {
			type: Boolean,
			required: false,
			default: false
		},
		manualError: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			showAgreement: false,
			value: false
		};
	},

	template: `
		<div class="agreement-wrapper">
			<label class="checkbox-container agreement" v-if="!readOnly">
				Согласен на <a @click.prevent="showAgreement = true">обработку персональных данных</a>
				<input type="checkbox" v-model="model" :value="value"/>
				<span class="checkmark"></span>
				<span class="input-item__error">{{ manualError }}</span>
			</label>
			<Modal v-if="showAgreement" @close="showAgreement = false">
				<template v-slot:body>
					<div class="modal-body__agreement">
						<p>Согласие на обработку персональных данных.</p><br>
						<p>Пользователь, оставляя заявку, оформляя подписку, комментарий, запрос на обратную связь, регистрируясь либо совершая иные действия, связанные с внесением своих персональных данных на интернет-сайте www.tececlub.ru, принимает настоящее Согласие на обработку персональных данных (далее – Согласие), размещенное по адресу: www.tececlub.ru.</p>
						<p>Принятием Согласия является подтверждение факта согласия Пользователя со всеми пунктами Согласия. Пользователь дает свое согласие организации ООО «ТЕСЕ Системс», которой принадлежит сайт www.tececlub.ru на обработку своих персональных данных со следующими условиями:</p>
						<p>Пользователь дает согласие на обработку своих персональных данных, как без использования средств автоматизации, так и с их использованием. Согласие дается на обработку следующих персональных данных:</p>
						<p>- Фамилия, Имя, Отчество;</p>
						<p>- Дата рождения</p>
						<p>- Телефон</p>
						<p>- E-mail адрес</p>
						<p>- Адрес регистрации по месту жительства</p>
						<p>- ссылка на персональные страницы в социальных сетях</p>
						<p>- Фотографию</p> 
						<p>- Данные о компании-работодателе</p>
						<p>- Данные о себе (профессиональная информация)</p>
						<p>Персональные данные пользователя не являются общедоступными.</p>
						<p>1. Целью обработки персональных данных является предоставление полного доступа к функционалу сайта www.tececlub.ru.</p>
						<p>2. Основанием для сбора, обработки и хранения персональных данных являются:</p>
						<p>статьи 23, 24 Конституции Российской Федерации;</p>
						<p>статьи 2, 5, 6, 7, 9, 18-22 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»;</p>
						<p>устав ООО «ТЕСЕ Системс»;</p>
						<p>политика обработки персональных данных.</p>
						<p>3. В ходе обработки с персональными данными будут совершены следующие действия с персональными данными: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (распространение, предоставление, доступ), обезличивание, блокирование, удаление уничтожение.</p>
						<p>4. Передача персональных данных, скрытых для общего просмотра, третьим лицам не осуществляется, за исключением случаев, предусмотренных законодательством Российской Федерации.</p>
						<p>5. Пользователь подтверждает, что указанные им персональные данные принадлежат лично ему.</p>
						<p>6. Персональные данные хранятся и обрабатываются до момента ликвидации ООО «ТЕСЕ Системс». Хранение персональных данных осуществляется согласно Федеральному закону от 22.10.2004 г. № 125-ФЗ «Об архивном деле в Российской Федерации» и иным нормативно-правовым актам в области архивного дела и архивного хранения.</p>
						<p>7. Пользователь согласен на получение информационных сообщений с сайта www.tececlub.ru. Персональные данные обрабатываются до отписки Пользователя от получения информационных сообщений.</p>
						<p>8. Согласие может быть отозвано Пользователем либо его законным представителем, путем направления отзыва согласия на электронную почту info@tececlub.ru указав в теме письма «Отзыв согласия на обработку персональных данных». В случае отзыва Пользователем согласия на обработку персональных данных ООО «ТЕСЕ Системс» вправе продолжить обработку персональных данных без согласия Пользователя при наличии оснований, указанных в пунктах 2-1 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных». Удаление персональных данных влечет невозможность доступа к полной версии функционала сайта www.tececlub.ru.</p>
						<p>9. Настоящее согласие является бессрочным, и действует все время до момента прекращения обработки персональных данных, указанных в п. 7 и п. 8 данного Согласия.</p>
						<p>10. Место нахождения ООО «ТЕСЕ Системс» в соответствии с учредительными документами:  143421, Московская область, Красногорский район, автодорога Балтия, тер 26 км бизнес-центр Рига-Ленд, строение А, этаж 5, помещение 14, ком 3.</p>
						<p>11. ООО «ТЕСЕ Системс» зарегистрирован в реестре Операторов, осуществляющих обработку персональных данных за номером 77-19-014978 на основании Приказа № 111 от 05.07.2019 года.</p>
					</div>
				</template>
			</Modal>
		</div>
	`,

	computed: {
		model: {
			get() {
				return this.checked;
			},
			set(val) {
				this.$emit('change', val);
			},
		},
	},

	components: {
		Modal: Modal
	}
};
